const reducer = {
  setFieldAppInstance(state, action) {
    const { field, value } = action.payload ?? {};
    if (field) {
      state[field] = value;
    }
  },
  addItemAppInstance(state, action) {
    if (state.list?.length >= 0) {
      state.list.push(action.payload);
    }
  },
  removeItemAppInstance(state, action) {
    state.list.Items = state.list.Items.filter(
      (e) => e.Id !== action.payload?.Id,
    );
  },
};

export default reducer;
